import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Pipe, PipeTransform } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { Config } from 'src/app/app-constant';
import { ToastController } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { forkJoin, iif } from 'rxjs';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';
import { calculateFiscalYear, formatYearRanges} from 'src/app/shared/commen-function-file';


@Component({
  selector: 'app-add-program-for-hod-popup',
  templateUrl: './add-program-for-hod-popup.component.html',
  styleUrls: ['./add-program-for-hod-popup.component.scss'],
})
export class AddProgramForHodPopupComponent  implements OnInit {

  subModuleButtonColor: any | null;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRole: any;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: any;
  fromYear: any;
  selectedYear: any;
  toYear: any;
  selectedYearForCompetency: any = null;
    pmsYears: any = [];
  programForm!: FormGroup;
  selectedTabIndex: number = 0;  // Default tab is "Create Calendar"

    selectedTypeTabIndex: number = 0;
    selectedTypeTabName = 'createcalendar'
    buttonColorName: any;
    showSetupPopup: boolean = false;
  getHodCalendor: any;
  addProgramForm: FormGroup;
  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
  private datePipe: DatePipe, public sharedService: SharedService,
  private loader: LoaderService, private encryptionService: EncryptionService,
  private httpService: HttpService, private config: Config, public router: Router,
  private fb: FormBuilder, public dialog: MatDialog,
  private activatedroute: ActivatedRoute, private toastr: ToastrService,
  private toastController: ToastController,
  private cdRef: ChangeDetectorRef,
  private PdfDownload: PdfDownloadService, private dataRefreshService: DataRefreshService, public dialogRef: MatDialogRef<AddProgramForHodPopupComponent>
)  {

  this.addProgramForm = this.fb.group({ 
    programTitle: ['', Validators.required],
    programDetails: ['', Validators.required],
    startDate: ['', Validators.required], 
    endDate: ['', Validators.required],
    brochure: [null, Validators.required]
  });
}

      ngOnInit() {
        this.selectedTypeTabName = "createcalendar";
        this.buttonColorName = sessionStorage.getItem('buttonColorName');
        this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
        this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    
        console.log('loggedInUserCompanyID Value:', this.loggedInUserCompanyID); // Debugging
    
        this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
        this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
        if (this.loggedInCompanyFiscalyear) {
          this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
        }
        this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
        this.loggedInUserId = sessionStorage.getItem('loggedInUserName');
        this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
        this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
        if (this.loggedInUserRole) {
          this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
        }
        this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
        this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
        if (this.loggedInUserRoles.length == 1) {
          for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
            if (this.loggedInUserRoles[i].displayName == "Employee") {
              this.loggedInUserRoleIsEmployee = true
            }
          }
        }
        this. getpmsyearlist();
      }
    
    
      getpmsyearlist() {
        this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
          this.pmsYears = formatYearRanges(data?.data?.yearRanges);
    
          const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);
    
          const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
          
          this.setSelectedYear(yearValue);
    
        });
      }
      
      setSelectedYear(yearValue: string): void {
        const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
        if (selectedYearObj) {
              this.selectedYearForCompetency = selectedYearObj?.year;
             
              let test = selectedYearObj?.year.split('-');
              this.fromYear = test[0];
              this.toYear = test[1];
       
              [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
        }
      }
    
  
    
  
      getYearSetupForReimbursement(year: any) {
        this.selectedYearForCompetency = year;
    console.log(   this.selectedYearForCompetency);
    
        this.selectedYear = year;
       
      }


      openDialog(message: string, buttonText: string = 'OK', buttonColor: string = 'red', showSuccessIcon: boolean = false, showSuccessMessage: boolean = false, showCloseIcon: boolean = false) {
        return this.dialog.open(ConfirmationPopupComponent, {
          disableClose: false,
          height: '25%',
          width: '30%',
          data: {
            msg: message,
            btn2: buttonText,
            btn2BgColor: buttonColor,
            showSuccessIcon: showSuccessIcon,
            showSuccessMessage: showSuccessMessage,
            showCloseIcon: showCloseIcon
          }
        });
      }
      

      closeDialog() {
        this.dialogRef.close();
     }
   


  selectedFileName: string = '';
  fileUploadError: boolean = false;
  uploadedFile: File | null = null;
  
  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.uploadedFile = input.files[0];
      this.selectedFileName = this.uploadedFile.name;
      this.fileUploadError = false;
    }
  }
  

  submitTrainingProgram() {
    // if (this.addProgramForm.invalid) {
    //   return;
    // }
  
    const programPayload = this.addProgramForm.value;
  
    // If this is an update, include the ID or unique key
    if (this.data?.programData?.id) {
      programPayload.id = this.data.programData.id;
    }
  
  // if (this.addProgramForm.invalid) {
  //   this.addSubmitForm = true;
  //   this.addProgramForm.markAllAsTouched();
  //   return;
  // }

  // this.isSubmitting = true;



  const isEdit = !!this.data?.programData;
    const payload = {
      "programTitle": this.addProgramForm.value.programTitle,
      "programDetails": this.addProgramForm.value.programDetails,
      "startDate": this.addProgramForm.value.startDate,
      "endDate": this.addProgramForm.value.endDate,
      "brochure": this.addProgramForm.value.brochure,
      companyId: this.loggedInUserCompanyID,
      year: this.selectedYear || this.selectedYearForCompetency,
      fiscalYear:this.loggedInCompanyFiscalyear
       
    };
  
    this.httpService.callPostService(`${this.config.saveHODProgram}`, payload).subscribe({
      next: async (result: any) => {
        console.log('Saved successfully:', result);
        const msg = isEdit ? 'Training program for HOD updated successfully' : 'Training program created successfully';
        this.openDialog(msg, 'OK', this.buttonColorName, false, false, false);
        this.dialogRef.close('updated'); // pass back to trigger refresh
        // this.isSubmitting = false;
      },
      error: async (err: any) => {
        this.openDialog(err.error.message || 'Something went wrong', 'OK', 'red', false, false, false);
        // this.isSubmitting = false;
      }
    });
  }
  
  selectedDepartment: any =[];
  getDepartmentsList: any[]=[];
  // add Training Program Dropdown

  // =================== Dropdown for Department ================
  dropdownSettings = {
    singleSelection: false,  // or true based on your requirement
    idField: 'id',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 1,
    allowSearchFilter: true
  };

  onDepartmentSelect(){

  }

  onDepartmentDeSelect(){

  }

  onDepartmentAllSelect(){

  }

  onDepartmentAllDeSelect(){

  }
}
